import OrdersTableModule from './OrdersTable.module';

export * from './OrdersTableModuleProps';
export * from './OrdersTableRef';
export default OrdersTableModule;
